import { getQueryParams } from '@zonofi/common';
import { Api } from '../api';
import {
  AgentSettingsUpdateRequest,
  AgentSettingsResponse,
  AgentSettingsGetRequest,
  AudienceRequest,
  AudienceResponse,
  UpdateAudienceRequest,
  AgentGuidanceGetRequest,
  AgentGuidanceGetResponse,
  AgentGuidanceUpdateResponse,
  AgentGuidanceUpdateRequest,
  customIntentsResponse,
} from './model';

export const agentApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    getAgentSettings: builder.query<
      AgentSettingsResponse,
      AgentSettingsGetRequest
    >({
      query: (args) => ({
        url: `hub/bot/api/v1/agent-settings/${args.sellerWorkspaceId}`,
        method: 'GET',
        params: args,
      }),
      providesTags: ['AgentSettings'],
    }),
    getAgentGuidance: builder.query<
      AgentGuidanceGetResponse[],
      AgentGuidanceGetRequest
    >({
      query: (args) => ({
        url: `hub/bot/api/v1/agent-guidance/${args.sellerWorkspaceId}`,
        method: 'GET',
        params: args,
      }),
    }),
    updateAgentGuidance: builder.mutation<
      AgentGuidanceUpdateResponse[],
      AgentGuidanceUpdateRequest
    >({
      query: (args) => ({
        url: `hub/bot/api/v1/agent-guidance/${args.params.sellerWorkspaceId}`,
        method: 'PATCH',
        params: args.params,
        body: args.body,
      }),
    }),
    updateAgentSettings: builder.mutation<
      AgentSettingsResponse,
      AgentSettingsUpdateRequest
    >({
      query: ({ sellerWorkspaceId, ...body }) => ({
        url: `hub/bot/api/v1/agent-settings/${sellerWorkspaceId}`,
        method: 'PATCH',
        params: { sellerWorkspaceId },
        body,
      }),
      invalidatesTags: ['AgentSettings'],
    }),
    getAgentAudience: builder.query<AudienceResponse, AudienceRequest>({
      query: (args) => ({
        url: `hub/orgs/api/agent/audience/${args.sellerWorkspaceId}?${getQueryParams(args)}`,
        method: 'GET',
      }),
    }),
    updateAgentAudience: builder.mutation<
      { status: string; statusCode: number },
      UpdateAudienceRequest
    >({
      query: ({ inviteIds, ...params }) => ({
        url: `hub/orgs/api/agent/audience/update`,
        method: 'POST',
        params,
        body: { inviteIds },
      }),
    }),
    updateCustomIntent: builder.mutation<any, any>({
      query: ({ body, params }) => ({
        url: `hub/bot/api/v1/custom-intents/${params.sellerWorkspaceId}`,
        method: 'POST',
        params,
        body: body,
      }),
    }),
    deleteCustomIntent: builder.mutation<any, any>({
      query: (args) => ({
        url: `hub/bot/api/v1/custom-intents/${args.sellerWorkspaceId}/${args?.id}`,
        method: 'DELETE',
        body: { sellerWorkspaceId: args.sellerWorkspaceId },
      }),
    }),
    getCustomIntents: builder.query<customIntentsResponse[], AudienceRequest>({
      query: (args) => ({
        url: `hub/bot/api/v1/custom-intents/${args.sellerWorkspaceId}`,
        method: 'GET',
        params: { sellerWorkspaceId: args.sellerWorkspaceId },
      }),
    }),
  }),
});

export const {
  useLazyGetAgentSettingsQuery,
  useUpdateAgentSettingsMutation,
  useLazyGetAgentAudienceQuery,
  useUpdateAgentAudienceMutation,
  useLazyGetAgentGuidanceQuery,
  useUpdateAgentGuidanceMutation,
  useLazyGetCustomIntentsQuery,
  useDeleteCustomIntentMutation,
  useUpdateCustomIntentMutation,
} = agentApi;
